export default __webpack_public_path__ + "static/IMG_0008-ConvertImage-scaled-e1583853200853-1024x1024-1-55af5671ca8c8b28f1b065b4657d4b14.jpg";